// extracted by mini-css-extract-plugin
export var textInput = "_fw-0";